import React from "react";

const Posts = () => {
  return (
    <>
      <div className="container">
        <h1>Stay Tuned!</h1>
      </div>
    </>
  );
};

export default Posts;
